import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { apolloErrorType } from '../../types';
import './_styles_/Error.css';

Error.propTypes = {
    className: PropTypes.string.isRequired,
    error: apolloErrorType,
};

Error.defaultProps = {
    error: {},
};

function Error(props) {
    const {
        className,
        error,
    } = props;
    const { t } = useTranslation();
    const {
        graphQLErrors,
        networkError,
    } = error;
    return (
        <div className={`system-error ${className}`}>
            <div className="system-error--box">
                <h4><FontAwesomeIcon icon="exclamation-triangle" />&nbsp;{t('errors.title')}</h4>
                {graphQLErrors && graphQLErrors.length > 0 && (
                    <div><FontAwesomeIcon icon="info-circle" className="system-error--text-icon" />&nbsp;{t('errors.graphql')}</div>
                )}
                {networkError && (
                    <div><FontAwesomeIcon icon="info-circle" className="system-error--text-icon" />&nbsp;{t('errors.network')}</div>
                )}
                <div><FontAwesomeIcon icon="lightbulb" className="system-error--text-icon" />&nbsp;{t('errors.reload')}</div>
            </div>
        </div>
    );
}

export default Error;
